module.exports = __webpack_public_path__ + "static/sound/stage1.76878e075.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/music/stage1.mp3
// module id = 600
// module chunks = 1